module.exports = __webpack_public_path__ + "img/368.57c57f75.jpg";